// extracted by mini-css-extract-plugin
module.exports = {"auth":"Login_auth__788OU","control":"Login_control__13yHz","actions":"Login_actions__3UGRv","toggle":"Login_toggle__ragBn","error":"Login_error__1K3mf"};